import { render, staticRenderFns } from "./CartAlert.vue?vue&type=template&id=1352965e&"
import script from "./CartAlert.vue?vue&type=script&lang=js&"
export * from "./CartAlert.vue?vue&type=script&lang=js&"
import style0 from "./CartAlert.vue?vue&type=style&index=0&id=1352965e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports